import axios from "axios";
import "./request_interceptor";


//const end_point1 = "http://192.168.30.225:88/api/stock_service/";
//const end_point1 = "https://preprodb.portailachats.ma/api/stock_service/";

const end_point1 = process.env.REACT_APP_API_URL + "/api/stock_service/";

////////////////////////////////////////////////////
////
////////////////////////////////////////////////////

export const view_stock = async (page) => {
  return await axios.get(end_point1 + "view_stock?page=" + page);
};

export const verify_products_existance_in_stock = async (data) => {
  return await axios.post(
    end_point1 + "verify_products_existance_in_stock",
    data
  );
};

export const add_product_to_stock = async (data) => {
  return await axios.post(end_point1 + "add_product_to_stock", data);
};

export const add_products_to_stock_by_import = async (data) => {
  return await axios.post(end_point1 + "add_products_to_stock_by_import", data);
};

export const update_product_in_stock = async (data) => {
  return await axios.post(end_point1 + "update_product_in_stock", data);
};

export const update_products_in_stock_by_import = async (data) => {
  return await axios.post(
    end_point1 + "update_products_in_stock_by_import",
    data
  );
};

export const search_filter_Stock= async(data)=>{
    return await axios.post(end_point1+'search_filter_Stock',data);

}
export const getByProdRef = async(prod_ref) => {
    return await axios.get(end_point1 + 'getByProdRef', {
        params: { prod_ref }
    });
}

export const getByProdCode = async(prod_code) => {
    return await axios.get(end_point1 + 'getByProdCode', {
        params: { prod_code }
    });
}

export const delete_from_stock= async(data)=>{
    return await axios.post(end_point1+'delete_from_stock',data);

}
// export const view_Stock_Transactions= async(pageNumber,perPage)=>{
//     return await axios.get(end_point1+'view_Stock_Transactions?page='+pageNumber+'&per_page='+perPage);
// export const view_Stock_Transactions= async(pageNumber,perPage)=>{
//     return await axios.get(end_point1+'view_Stock_Transactions?page='+pageNumber+'&per_page='+perPage);

// }

export const view_Stock_Transactions = (page, perPage) => {
    return axios.get(end_point1+'view_Stock_Transactions', {
      params: { page, per_page: perPage },
    });
  };
  
// }